var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTestMediaIcon = function SvgTestMediaIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72.748,
    height: 56.254,
    viewBox: "0 0 72.748 56.254",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6326",
    "data-name": "Grupo 6326",
    transform: "translate(0.501 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6327",
    "data-name": "Grupo 6327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8552",
    "data-name": "Caminho 8552",
    d: "M67.623,0H55.253a4.128,4.128,0,0,0-4.123,4.123v9.072H8.246a4.129,4.129,0,0,0-4.123,4.123V46.182a4.081,4.081,0,0,0,.846,2.474H3.3a3.3,3.3,0,1,0,0,6.6H62.675a3.3,3.3,0,1,0,0-6.6H61a4.081,4.081,0,0,0,.846-2.474V37.111h5.773a4.128,4.128,0,0,0,4.123-4.123V4.123A4.128,4.128,0,0,0,67.623,0M5.772,17.318a2.477,2.477,0,0,1,2.474-2.474H51.129V32.987a4.128,4.128,0,0,0,4.123,4.123H60.2v9.072a2.477,2.477,0,0,1-2.474,2.474H8.246a2.477,2.477,0,0,1-2.474-2.474Zm56.9,32.987a1.649,1.649,0,0,1,0,3.3H3.3a1.649,1.649,0,1,1,0-3.3H62.675ZM70.1,32.987a2.477,2.477,0,0,1-2.474,2.474H55.253a2.477,2.477,0,0,1-2.474-2.474V4.123a2.477,2.477,0,0,1,2.474-2.474h12.37A2.477,2.477,0,0,1,70.1,4.123Z",
    transform: "translate(0)",
    fill: "#1f35b5",
    stroke: "#1f35b5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6328",
    "data-name": "Grupo 6328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8553",
    "data-name": "Caminho 8553",
    d: "M44.879,40.786l-2.648,4.363h14l-2.667-4.363a7.563,7.563,0,1,0-8.688,0m4.344-10.211v0a4.041,4.041,0,1,1-4.041,4.041,4.041,4.041,0,0,1,4.041-4.041",
    transform: "translate(-7.303 -4.739)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8554",
    "data-name": "Caminho 8554",
    d: "M50.269,38.411a2.639,2.639,0,1,0-2.639-2.639,2.639,2.639,0,0,0,2.639,2.639",
    transform: "translate(-8.35 -5.809)",
    fill: "#1f35b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8555",
    "data-name": "Caminho 8555",
    d: "M25.954,43.689v3.239l1.432,0V43.691a6.5,6.5,0,0,0,4.239-2.119A6.246,6.246,0,0,0,33.34,37.19H31.911a4.855,4.855,0,0,1-1.536,3.643,5.393,5.393,0,0,1-7.414,0A4.866,4.866,0,0,1,21.43,37.19H20a6.25,6.25,0,0,0,1.715,4.38,6.5,6.5,0,0,0,4.239,2.119",
    transform: "translate(-3.506 -6.52)",
    fill: "#1f35b5",
    stroke: "#1f35b5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8556",
    "data-name": "Caminho 8556",
    d: "M27.351,38.572a3.456,3.456,0,0,0,3.455-3.455V30.509a3.455,3.455,0,0,0-6.911,0v4.607a3.456,3.456,0,0,0,3.455,3.455",
    transform: "translate(-4.189 -4.743)",
    fill: "#1f35b5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8557",
    "data-name": "Caminho 8557",
    d: "M74.237,4a1.237,1.237,0,1,0,1.237,1.237A1.237,1.237,0,0,0,74.237,4",
    transform: "translate(-12.798 0.299)",
    fill: "#1f35b5",
    stroke: "#1f35b5",
    strokeWidth: 1
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTestMediaIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/test-media-icon.aa4c65fe.svg";
export { ForwardRef as ReactComponent };